import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { BlankView, BlankViewImageSizes, BlankViewImageVariants } from 'src/Components/blank-view'

const SmartMeterGatewayInfoPanel: React.FC = () => {
  const { t } = useCustomTranslation()

  return (
    <AccordionItem title={t('installation-configuration.em360.smg-controlbox.title')} expanded accordionDetailsSx={{ px: 4, py: 2 }}>
      <BlankView
        imageVariant={BlankViewImageVariants.Happy}
        imageSize={BlankViewImageSizes.Small}
        title={''}
        explanation={t('installation-configuration.em360.smg-controlbox.farm-info.explanation')}
      />
    </AccordionItem>
  )
}

export default SmartMeterGatewayInfoPanel
